import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import Backend from 'i18next-http-backend'
import { initReactI18next } from 'react-i18next'

import enTranslations from './locales/en-US'
import esTranslations from './locales/es-ES'
import ptTranslations from './locales/pt-BR'

const resources = {
  en: { ...enTranslations },
  pt: { ...ptTranslations },
  es: { ...esTranslations },
}

i18n.use(Backend).use(LanguageDetector).use(initReactI18next).init({
  resources,
  debug: false,
  fallbackLng: 'pt',
  defaultNS: 'translations',
})

export default i18n
